import React, { useState, useEffect, useContext } from 'react';
import {
  func, string, object, bool,
} from 'prop-types';
import { Box } from '@material-ui/core';
import {
  MoreVert as MoreVertIcon, CloseOutlined,
} from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import cookies from 'react-cookies';
import SuccessDetail from '../SuccessDetail';
import WarningDetail from '../WarningDetail';
import CloseDetail from '../CloseDetail';
import IndividualDetail from '../IndividualDetail';
import { getNotificationData, getNotificationCount } from '../../../utils/api/endpoints';
import { formatNotificationDate } from '../../../utils/formatDate';
import { isMobile } from '../../../utils/getDeviceType';
import backIcon from '../assets/back.svg';
import HomeContext from '../../../home/HomeContext';

const useStyles = makeStyles(() => ({
  notificationTitle: {
    fontFamily: 'Montserrat',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#181818',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  notificationDesc: {
    fontFamily: 'Montserrat',
    fontSize: '16px',
    lineHeight: '24px',
    color: '#181818',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  notificationDate: {
    fontFamily: 'Montserrat',
    fontSize: '12px',
    display: 'flex',
    textAlign: 'center',
    color: '#181818',
    marginRight: 18,
    alignItems: 'flex-start',
    lineHeight: '24px',
    whiteSpace: 'nowrap',
  },
  notifyDetailWrapper: {
    height: 'calc(100% - 81px)',
    overflowY: 'auto',
  },
  toolBar: {
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'space-between',
    height: 80,
    padding: '24px 24px 8px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.0784)',
  },
  notificationDetailSelect: {
    position: 'absolute',
    top: 'calc(50% + 6px)',
    left: e => (e.language === 'ar' ? -24 : 'unset'),
    right: e => (e.language === 'ar' ? 'unset' : -24),
    zIndex: 10,
    padding: '12px',
    border: '1px solid #E4EDED',
    boxSizing: 'border-box',
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
    borderRadius: '4px',
    background: '#ffffff',

    '&::before': {
      content: "''",
      position: 'absolute',
      top: -10,
      right: 26,
      zIndex: 10,
      borderBottom: '10px solid #E4EDED',
      borderLeft: '9px solid transparent',
      borderRight: '9px solid transparent',
      width: 0,
      height: 0,
    },
    '&::after': {
      content: "''",
      position: 'absolute',
      top: -9,
      right: 26,
      zIndex: 10,
      borderBottom: '10px solid #FFFFFF',
      borderLeft: '9px solid transparent',
      borderRight: '9px solid transparent',
      width: 0,
      height: 0,
    },
  },
  notificationDetailSelectItem: {
    padding: '0 6px',
    fontFamily: 'Montserrat',
    fontSize: 14,
    lineHeight: '34px',
    color: '#181818',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    '&:hover': {
      background: '#F6F9F9',
    },
  },
}));

const NotificationDetail = ({
  clickId,
  setclickId,
  notifycation: {
    id, header, name, middleName, surName, createDate,
  },
  callApi,
  onReadOrDelete,
  redirectTo,
  snsInfo,
  snsList,
  setListSelect,
  displayDetailSelect,
  setDisplayDetailSelect,
}) => {
  const { detailSelectList } = snsList;
  const langCd = cookies.load('langCd');
  const mrktCd = cookies.load('mrktCd');
  const classes = useStyles({ language: langCd });

  // eslint-disable-next-line
  const [{ }, dispatch] = useContext(HomeContext);

  // eslint-disable-next-line
  const [notifycationTypeDetail, setNotifycationTypeDetail] = useState({});

  const handleClickMore = () => {
    setDisplayDetailSelect(!displayDetailSelect);
  };

  const handleClickSelectItem = async (type) => {
    onReadOrDelete(id, type === 'delete' ? '' : 'READ');
    if (type === 'delete') {
      setclickId('');
    }
    setDisplayDetailSelect(false);
  };

  const getNotificationNumber = async () => {
    const { unreadCount: count } = await callApi(getNotificationCount());
    dispatch({ unreadCount: count === 0 ? '0' : count });
  };

  useEffect(() => {
    const getNotificationDetail = async () => {
      const res = await callApi(getNotificationData(id));
      setNotifycationTypeDetail(res || {});
      getNotificationNumber();
    };
    getNotificationDetail();
  }, [clickId]);

  const toggleShow = () => {
    setDisplayDetailSelect(false);
  };

  useEffect(() => {
    document.addEventListener('click', toggleShow, false);

    return () => {
      document.removeEventListener('click', toggleShow);
    };
  });

  const handleRenderDetail = () => {
    const { category, pushType } = notifycationTypeDetail;

    if (['newLead', 'delegateLead', 'rejected_7days', 'expire', 'survey'].indexOf(category) !== -1) {
      return (
        <WarningDetail
          notifycationDetail={notifycationTypeDetail}
          setclickId={setclickId}
          redirectTo={redirectTo}
          snsInfo={snsInfo}
        />
      );
    } if (['rejected_expire', 'rejected_delete', 'rejected'].indexOf(category) !== -1) {
      return (
        <CloseDetail
          notifycationDetail={notifycationTypeDetail}
          setclickId={setclickId}
          snsInfo={snsInfo}
        />
      );
    } if (['completed'].indexOf(category) !== -1) {
      return (
        <SuccessDetail
          notifycationDetail={notifycationTypeDetail}
          setclickId={setclickId}
          snsInfo={snsInfo}
          callApi={callApi}
        />
      );
    } if (['INDIVIDUAL', 'BROADCAST'].indexOf(pushType) !== -1) {
      return (
        <IndividualDetail
          notifycationDetail={notifycationTypeDetail}
          setclickId={setclickId}
          redirectTo={redirectTo}
          snsInfo={snsInfo}
        />
      );
    }
    return <></>;
  };

  return (
    <>
      {
      isMobile() ? (
        <Box
          style={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '10px 0',
            borderBottom: '1px solid rgba(0, 0, 0, 0.0784)',
          }}
        >
          <Box
            style={{
              position: 'absolute',
              left: 16,
              width: 24,
              height: 24,
            }}
            onClick={() => setclickId('')}
          >
            <img src={backIcon} alt="back-icon" />
          </Box>
          <Box style={{
            fontFamily: 'Montserrat',
            fontWeight: 500,
            fontSize: 16,
            lineHeight: '24px',
            color: '#181818',
          }}
          >
            {formatNotificationDate(createDate, langCd, 'DD MMM, HH:mm',
              snsList.list ? snsList.list.toady : '',
              snsList.list ? snsList.list.yesterday : '')}
          </Box>
        </Box>
      ) : (
        <Box className={classes.toolBar}>
          <Box style={{
            display: 'flex',
            overflow: 'hidden',
          }}
          >
            <Box
              style={{ cursor: 'pointer' }}
              onClick={() => setclickId('')}
            >
              <CloseOutlined />
            </Box>
            <Box style={{
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              padding: '0 18px',
            }}
            >
              <Box className={classes.notificationTitle}>
                {header}
              </Box>
              <Box className={classes.notificationDesc}>
                {
                  // eslint-disable-next-line
                  (notifycationTypeDetail.pushType === 'INDIVIDUAL' || notifycationTypeDetail.pushType === 'BROADCAST') ? name
                    : ((['RU', 'PH', 'HU'].indexOf(mrktCd) !== -1) ? (
                      `${(surName || '') + (middleName ? (` ${middleName} `) : ' ') + (name || '')}`
                    ) : (
                      `${(name || '') + (middleName ? (` ${middleName} `) : ' ') + (surName || '')}`
                    ))
              }
              </Box>
            </Box>
          </Box>
          <Box style={{
            display: 'flex',
          }}
          >
            <Box className={classes.notificationDate}>
              {formatNotificationDate(createDate, langCd, 'DD MMM, HH:mm',
                snsList.list ? snsList.list.toady : '',
                snsList.list ? snsList.list.yesterday : '')}
            </Box>
            <Box style={{
              position: 'relative',
            }}
            >
              <Box
                style={{ cursor: 'pointer' }}
                onClick={(e) => {
                  e.nativeEvent.stopImmediatePropagation();
                  setListSelect(false);
                  handleClickMore();
                }}
              >
                <MoreVertIcon />
              </Box>
              <Box
                className={classes.notificationDetailSelect}
                style={{ display: displayDetailSelect ? 'unset' : 'none' }}
              >
                {
                  detailSelectList && detailSelectList.map(({ label, value }) => (
                    <Box
                      className={classes.notificationDetailSelectItem}
                      key={`notification-detail-select-key-${value}`}
                      onClick={() => handleClickSelectItem(value)}
                    >
                      {label}
                    </Box>
                  ))
                }
              </Box>
            </Box>
          </Box>
        </Box>
      )
    }
      <Box className={classes.notifyDetailWrapper}>
        {handleRenderDetail()}
      </Box>
    </>
  );
};

NotificationDetail.propTypes = {
  clickId: string,
  setclickId: func,
  notifycation: object,
  callApi: func,
  onReadOrDelete: func,
  redirectTo: func,
  snsInfo: object,
  snsList: object,
  setListSelect: func,
  displayDetailSelect: bool,
  setDisplayDetailSelect: func,
};

export default NotificationDetail;
